import '../../instrutor.styles.scss';
import Title from '../../../../components/title/title.component';
import { Button } from 'antd';
import './class-management.styles.scss';
import { useNavigate } from 'react-router-dom';
import useClassManagement from './use-class-management.hook';
import { ITurmaFullDTO } from '../../../../models/happy-code-api.model';
import ClassCard from '../class-card/class-card.component';
import { useTranslation } from 'react-i18next';

export default function ClassManagement() {
  const { userIsInstructor, hasOutgoingClass, outgoingClass, isB2B } =
    useClassManagement();
   const { t } = useTranslation('instrutor')

  const navigate = useNavigate();

  return (
    userIsInstructor && !isB2B && (
      <div className="instrutor__cards-wrapper">
        <div className="class-management__title-see-button">
          <Title title={t('instrutor:myIndicators')} />
          <Button onClick={() => navigate('/turmas')} className="button-line">
            {t('instrutor:classManagement')}
          </Button>
        </div>

        <div className="class-management__class-cards-wrapper">
          {hasOutgoingClass &&
            outgoingClass.map((turma: ITurmaFullDTO) => (
              <ClassCard t={t} turma={turma} key={turma.id} />
            ))}
        </div>
      </div>
    )
  );
}
